var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanFillType2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_3",
    "data-name": "Camada 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.42 264.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f25b19;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.76,220.35c28.05-58.76,1.09-92.51-34.34-117.13C91.93,69.55,109.23,0,109.23,0c-52.47,46.91-25.9,98.18-8.12,133.53,10.28,20.42,3.24,39.85-22.4,42.6-51.05,5.48-42.38-80.8-42.38-80.8C-22.25,164.36,6.59,215.61,10.77,220.46c0,0,25.26,43.59,82.43,43.68,61.75.09,81.55-43.79,81.55-43.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFillType2);
export default __webpack_public_path__ + "static/media/plan-fill-type-2.dab7b53075130757ac25176ad81e22d2.svg";
export { ForwardRef as ReactComponent };